/// <amd-module name="TFS/Admin/Groups/Pivots/Users/Redux/UsersPivotSelectors" />
import { IUsersPivotAwareState, ISearchResultCache } from "TFS/Admin/Groups/Common/Contracts";
import { GraphUser } from "VSS/Platform/Contracts/Graph";
import { MessageCardSeverity } from "VSSUI/MessageCard";
import { SearchStatus } from "TFS/Admin/Groups/Common/Constants";

export function getUsers(state: IUsersPivotAwareState): GraphUser[] {
    if (!state || !state.usersState || !state.usersState.data) {
        return [];
    }

    if (state.usersState.data.totalIdentityCount > 0) {
        return state.usersState.data.identities;
    }

    return [];
}

export function fetchMoreDataOnLastRow(state: IUsersPivotAwareState): boolean {
    if (!state || !state.usersState || !state.usersState.data) {
        return true;
    }

    return state.usersState.data.moreData;
}

export function getTotalIdentityCount(state: IUsersPivotAwareState): number {
    if (!state || !state.usersState || !state.usersState.data) {
        return 0;
    }

    return state.usersState.data.totalIdentityCount;
}

export function getContinuationToken(state: IUsersPivotAwareState): string[] | undefined {
    if (!state || !state.usersState || !state.usersState.data) {
        return undefined;
    }

    return state.usersState.data.continuationToken;
}

export function showLoadingPanel(state: IUsersPivotAwareState): boolean {
    if (!state || !state.usersState) {
        return true;
    }
    return state.usersState.loading;
}

export function getSearchResult(state: IUsersPivotAwareState): ISearchResultCache {
    if (!state || !state.usersState) {
        return {
            keyword: "",
            resultItems: [],
            status: SearchStatus.None,
            hasMore: false
        };
    }
    return state.usersState.searchResult;
}

export function getInitComplete(state: IUsersPivotAwareState): boolean {
    if (!state || !state.usersState) {
        return false;
    }
    return state.usersState.initComplete;
}

export function getMessageCardText(state: IUsersPivotAwareState): string | undefined {
    if (!state || !state.usersState) {
        return undefined;
    }

    return state.usersState.messageCardText;
}

export function getMessageCardSeverity(state: IUsersPivotAwareState): MessageCardSeverity | undefined {
    if (!state || !state.usersState) {
        return undefined;
    }

    return state.usersState.messageCardSeverity;
}
